import { Accordion, AccordionDetails, AccordionSummary, Container, makeStyles, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import React from 'react'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSystemMetrics } from '../../actions';


const useStyles = makeStyles((theme) => ({
    root: {
        textAlign: 'center',
    }, heading: {
        fontSize: theme.typography.pxToRem(20),
        fontWeight: theme.typography.fontWeightRegular,
        margin: '5px'
    }, mainTitle: {
        margin: '20px 0px'
    }, overViewTitle: {
        margin: '40px 0px 10px',
    }, overviewBody: {
        textAlign: 'left',
        lineHeight: '1.9',
    }, faq: {
        margin: '40px 0px 21px'
    }, accordionContainer: {
        marginBottom: '40px'
    }, overViewSummaryIntro: {
        margin: '10px 0px 10px'
    }, constructionContainer: {
        border: '1px solid',
        padding: '25px 10px',
        margin: '20px 0px'
    }, accordionDetails: {
        textAlign: 'left'
    }

}));

const questionList = [
    {
        title: 'What is the point of this website?',
        content: "To actually learn words. A lot of the apps nowadays feel so heavy with features. I just wanted to be able to learn a word with minimal effort and not put to much time into it. Also, as I read books I would come across words that I didn't know and have no fun way to keep track of them. This app solves that problem."
    },
    {
        title: 'How often will I see the words I know?',
        content: "Currently, you will see the word according to your proficiency. I'll be testing different gaps to find the sweet spot. But for example the test gaps will look something like this. At a proficiency of 1 you'll see the word in 3-6 days. Then at a proficiency of 3, you'll see it in 3 months. And it continues to get farther and farther."

    },
    {
        title: 'What is proficiency?',
        content: "Proficiency is a measure of how well you know a word. It's increased every time you are tested on a word and get it correct."
    },
    {
        title: 'What do I do with my Word Money?',
        content: 'Take over the world! Just kidding, there is no use yet. But if you have any ideas let me know!'
    },
    {
        title: 'How can I give feedback?',
        content: `Email me! Or shoot me a text if you're part of the inner circle`
    }
]



const AboutPage = () => {
    const theme = useTheme();
    const classes = useStyles(theme);
    const isMdOrUp = useMediaQuery(theme.breakpoints.up("sm"));
    const dispatch = useDispatch();
    const systemMetrics = useSelector(state => state.systemMetrics)

    if (systemMetrics === null) {
        dispatch(fetchSystemMetrics());
    }

    const renderAccordionItems = (questionList) => {
        return questionList.map((element) => {
            return (
                <Accordion key={element.title}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography className={classes.heading} >
                            {element.title}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography className={classes.accordionDetails} color='textSecondary'>
                            {element.content}
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            )

        })


    }





    return (
        <Container maxWidth='md' className={classes.root}>
            <Typography className={classes.mainTitle} variant={isMdOrUp ? 'h1' : 'h2'}>
                How it Works
            </Typography>

            <Typography color='primary' className={classes.overViewTitle} variant={isMdOrUp ? 'h4' : 'h4'}>
                Overview
            </Typography>
            <Typography className={classes.overViewSummaryIntro} variant='body1'>
                This website was created in order to learn vocabulary with a minimalism focus. Using Word Bank is simple.
            </Typography>
            <Container className={classes.constructionContainer}>
                <Typography component='ol' className={classes.overviewBody} variant='body1'>

                    <li>Go to the Word Market.</li>
                    <li>Pick a word and it gets added to your dashboard</li>
                    <li>Then in 24 hours from picking that word, you're tested on that word.</li>
                    <li>The test consists of you recalling the definition of the word and typing it out</li>
                    <li>Then you are shown the definition. You decide whether or not you know the word. The test is based on the honor system.</li>
                    <li>If you test correctly then that word gets added to your word bank if it hasn't been already. You'll be tested again in larger time gaps as your proficiency increases. Each time you get the word
                correct you gain Word Money which also increases as proficiency increases.</li>
                    <li>If you get the word wrong you pay a small fee if the word is already in your word bank. You don't pay a fee if you haven't learned the word yet. You test it again the next day. You don't lose proficiency.</li>


                </Typography>
            </Container>
            <Typography className={classes.overViewSummaryIntro} variant='body1'>
                As of now, there is no use for the Word Money (should probably come up with a better name) but I will probably be programming something fun later. Also I'm not much of a designer, the graphics are not so great. I'll also be taking suggestions for that.

            </Typography>

            <Typography className={classes.faq} color='primary' variant={isMdOrUp ? 'h4' : 'h4'}>
                Frequently Asked Questions
            </Typography>


            <Container className={classes.accordionContainer} maxWidth='md'>
                {renderAccordionItems(questionList)}
            </Container>


        </Container>
    )
}

export default AboutPage;
